import { suluInstance } from 'src/utils/axios';

class AccountsServiceService {
  getBySubId = async (subId) => {
    return suluInstance
      .get(`/accounts/${subId}`)
      .then((res) => {
        const subscriptions = res.data.data.attributes.subscriptions.data;

        return subscriptions.map((b) => ({
          value: b.id,
          label: b.attributes.account.data.attributes.cached_name,
        }));
      })
      .catch(() => {
        return [];
      });
  };

  checkFlipper = async (subId) => {
    return suluInstance
      .get(`/feature_flag_status?id=${subId}`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  };
}

export default new AccountsServiceService();
